export const TIPO_DOCUMENTO_ENUM = {
  FACTURA: 2,
  DNI: 3,
  PAGARE: 4,
  ALBARAN: 18,
  PEDIDO: 24,
  PRESUPUESTO: 25,
  FACTURA_RECURRENTE: 30,
  ERROR: -1,
} as const

export type TipoDocumentoEnumType =
  (typeof TIPO_DOCUMENTO_ENUM)[keyof typeof TIPO_DOCUMENTO_ENUM]
